export const toggleListItem = (id,main) => {
	return {
		type: "TOGGLE",
		id: id,
		main: main
	}

}

export const addItem = (text,main) => {
	return {
		type: "ADD",
		text: text,
		main: main
	}
}

export const clearItems = (main) => {
	return {
		type: "CLEAR",
		main: main
	}
}

export const saveItems = () => {
	return {
		type: "SAVE"
	}
}

//bruh menu

export const changeMode = (goTo,name) => {
	return {
		type: goTo,
		main: name
	}
}

export const addMain = (name) => {
	return {
		type: "ADD_MAIN",
		name: name
	}
}